const getDefaultUser = () => {
    let user1 = localStorage.getItem("user1");
    if (user1 && user1 !== "undefined") {
        return JSON.parse(user1);
    } else {
        return {};
    }
};
const authHeader = () => {
    const user1 = localStorage.getItem("user1") ? getDefaultUser() : {};
    if (user1 && (user1?.token)) {
        return { Authorization: `${user1.token}` };
    } else {
        return {};
    }
};
export default authHeader;